import React from 'react';

import PortfolioLayout from '@totem/components/portfolio/overview/PortfolioLayout';
import SummaryContainer from '@totem/components/portfolio/overview/summary/SummaryContainer';

import ContentLayout from '../../ui_components/page/ContentLayout';

const Portfolio = () => {
  return (
    <ContentLayout landingPageName={'overview'}>
      <SummaryContainer>
        <PortfolioLayout />
      </SummaryContainer>
    </ContentLayout>
  );
};

export default Portfolio;
